<ng-container>
  <span style="display: block; margin-top: 30px">{{ 'MODAL_CERTIFICATIONS.CONTRACT.STATEMENT' | translate }}</span>
  <form [formGroup]="certificateForm">
    <mat-card class="mat-elevation-z0 b-0-5 my-16">
      <mat-card-content>
        <mat-radio-group formControlName="certificate">
          <ng-container *ngFor="let choice of certificates; let i = index">
            <mat-radio-button
              [value]="choice.value"
              [labelPosition]="'before'"
              [disabled]="isButtonDisabled(choice)"
              color="primary"
              class="row items-center justify-between py-10"
              [ngClass]="i !== certificates.length -1  ? 'bb-0-5' : ''">
              <div class="flex-col-container">
                <span [innerHTML]="choice.title | translate" class="fw-700 fs-14"></span>
                <span [innerHTML]="choice.description | translate" class="fs-12 lh-1"></span>
              </div>
            </mat-radio-button>
          </ng-container>
        </mat-radio-group>
      </mat-card-content>
    </mat-card>
    <div *ngIf="showYearField" @fadeInOut>
      <span class="fw-400 fs-14">{{ 'MODAL_CERTIFICATIONS.CONTRACT.TAX_YEAR' | translate }}</span>
      <mat-card class="mat-elevation-z0 b-0-5 my-16">
        <mat-form-field class="w-all">
          <mat-label>{{'CONTRACT.PAYMENTS.FILTERS.YEAR' | translate}}</mat-label>
          <mat-select formControlName="year">
            <mat-option *ngFor="let year of years" [value]="year"> {{year}} </mat-option>
          </mat-select>
        </mat-form-field>
      </mat-card>
    </div>
    <div *ngIf="showRactYearField" @fadeInOut>
      <span class="fw-400 fs-14">{{ 'MODAL_CERTIFICATIONS.CONTRACT.TAX_YEAR' | translate }}</span>
      <mat-card class="mat-elevation-z0 b-0-5 my-16">
        <mat-form-field class="w-all">
          <mat-label>{{'CONTRACT.PAYMENTS.FILTERS.YEAR' | translate}}</mat-label>
          <mat-select formControlName="year">
            <mat-option *ngFor="let year of ractYears" [value]="year"> {{year}} </mat-option>
          </mat-select>
        </mat-form-field>
      </mat-card>
    </div>
    <mat-card class="mat-elevation-z0 b-0-5 my-16" *ngIf="showCertificationType">
      <mat-card-content>
        <mat-radio-group formControlName="typeCertificate">
          <ng-container *ngFor="let type of typesCertificate; let i = index">
            <mat-radio-button
              [value]="type.product_type"
              [labelPosition]="'before'"
              [disabled]="isButtonDisabled(type)"
              color="primary"
              class="row items-center justify-between py-10"
              [ngClass]="i !== certificates.length -1  ? 'bb-0-5' : ''">
              <div class="flex-col-container">
                <span [innerHTML]="type.title | translate" class="fw-700 fs-14"></span>
              </div>
            </mat-radio-button>
          </ng-container>
        </mat-radio-group>
      </mat-card-content>
    </mat-card>
  </form>
</ng-container>
